import { Button, IconPhone16, UIHeading2, UIHeading4 } from '@cian/ui-kit';
import { TButtonSize } from '@cian/ui-kit/button/types';
import * as React from 'react';

import * as styles from './PhoneButton.css';
import { TextButton } from '../TextButton';

export type TPhoneButtonType = 'button' | 'text';

export interface IPhoneButtonProps {
  phone: string;
  phoneVisible: boolean;
  text?: string;
  size?: TButtonSize;
  withIcon?: boolean;
  type?: TPhoneButtonType;
  onClick(): void;
}

export const PhoneButton: React.FC<IPhoneButtonProps> = ({
  phone,
  phoneVisible,
  text = 'Контакты компании',
  size = 'XS',
  withIcon = false,
  type = 'button',
  onClick,
}) => {
  const isBig = size !== 'XS';

  const visiblePhone = React.useMemo(() => {
    return isBig ? <UIHeading2>{phone}</UIHeading2> : <UIHeading4>{phone}</UIHeading4>;
  }, [isBig, phone]);

  const button = React.useMemo(() => {
    return type === 'button' ? (
      <Button
        beforeIcon={withIcon ? <IconPhone16 color="white_100" /> : undefined}
        onClick={onClick}
        size={size}
        data-name="PhoneButton"
      >
        {text}
      </Button>
    ) : (
      <TextButton onClick={onClick} data-name="PhoneButton">
        {text}
      </TextButton>
    );
  }, [type, withIcon, onClick, size, text]);

  return <div className={styles['container']}>{phoneVisible ? visiblePhone : button}</div>;
};
